function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import styles from "./TextArea.module.sass";
const TextArea = props => {
  const {
    name,
    className,
    ...inputProps
  } = props;
  return /*#__PURE__*/React.createElement("label", {
    className: `${styles["container"]} ${className || ""}`
  }, /*#__PURE__*/React.createElement("h5", {
    className: styles["label"]
  }, name), /*#__PURE__*/React.createElement("textarea", _extends({
    className: styles["input"]
  }, inputProps)));
};
export default TextArea;